
import { useCurrency } from "@/contexts/CurrencyContext";
import { formatCurrency } from "@/lib/utils";

interface ProjectBudgetProps {
  cameraBudget?: number;
  geBudget?: number;
  cameraEnabled?: boolean;
  geEnabled?: boolean;
}

export const ProjectBudget = ({ 
  cameraBudget = 0, 
  geBudget = 0,
  cameraEnabled = true,
  geEnabled = true 
}: ProjectBudgetProps) => {
  const { currency } = useCurrency();
  
  // Calculate total from only enabled departments
  const totalBudget = (cameraEnabled ? cameraBudget : 0) + (geEnabled ? geBudget : 0);
  
  return (
    <>
      <div className="col-span-2 flex justify-between text-xs">
        <span className="text-muted-foreground">Total:</span>
        <span className="font-medium text-primary">
          {formatCurrency(totalBudget || 0, currency)}
        </span>
      </div>
      
      {cameraEnabled && (
        <div className="col-span-1 flex justify-between text-xs">
          <span className="text-muted-foreground">Camera:</span>
          <span className="font-medium">
            {formatCurrency(cameraBudget || 0, currency)}
          </span>
        </div>
      )}
      
      {geEnabled && (
        <div className="col-span-1 flex justify-between text-xs">
          <span className="text-muted-foreground">G&E:</span>
          <span className="font-medium">
            {formatCurrency(geBudget || 0, currency)}
          </span>
        </div>
      )}
    </>
  );
};
